import { store } from '../store/index';
import {
  filterForm,
  removeForm,
  modifyForm,
  getFormByUuid,
  createForm,
  filterAllForm
} from '../store/actions/FormActions';

/**
 * Create Form
 */
export const addForm = async (values) => {
  const objSend = { ...values };
  const result = await store.dispatch(createForm(objSend));
  if (result?.payload?.data?.uuid) {
    return 'OK';
  }
  return null;
};

/**
 * Get Form
 */
export const getForm = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(getFormByUuid(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Update Form
 */
export const updateForm = async (values, uuid) => {
  const objSend = { ...values };
  const result = await store.dispatch(modifyForm(objSend, [uuid]));
  if (result?.payload?.data?.uuid) {
    return 'OK';
  }
  return null;
};

/**
 * List Form
 */
export const listFilter = async (filter) => {
  const result = await store.dispatch(filterForm(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Delete Form
 */
export const deleteForm = async (uuid) => {
  const result = await store.dispatch(removeForm([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * List all Form
 */
export const listAllFilter = async (filter) => {
  const result = await store.dispatch(filterAllForm(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};